import { useCallback, useEffect } from 'react';

import { IGeoFormValue, IGeoStep, IGeoValue } from '../types';
import { ILocation } from '../../../types/location';
import { EStepField } from '../constants/stepField';

export interface IUseGeoFormValueProps {
  value?: IGeoFormValue;
  currentStep: IGeoStep;

  onChange(value: IGeoFormValue | ((preState: IGeoFormValue) => IGeoFormValue)): void;

  updateSteps(value: ILocation, initialStepField?: EStepField): void;
}

export const useGeoFormValue = ({ value, currentStep, onChange, updateSteps }: IUseGeoFormValueProps) => {
  const updateStepsOnInit = useCallback(() => {
    if (value?.location) {
      updateSteps(value.location, value.lastStep);
    }
  }, [updateSteps, value]);

  // oxlint-disable-next-line react/exhaustive-deps
  useEffect(updateStepsOnInit, []);

  useEffect(() => {
    onChange(value => ({
      ...value,
      lastStep: currentStep.field,
    }));
  }, [currentStep, onChange]);

  const onGeoValuesChange = useCallback(
    (values: IGeoValue[]) => {
      const newGeoValues = {
        ...value?.geoValues,
        [currentStep.field]: values,
      };
      onChange({
        location: value?.location,
        geoValues: newGeoValues,
        lastStep: currentStep.field,
      });
    },
    [value, currentStep, onChange],
  );

  const onLocationChange = useCallback(
    (newLocation: ILocation) => {
      updateSteps(newLocation);
      onChange({
        location: newLocation,
      });
    },
    [updateSteps, onChange],
  );

  return {
    onGeoValuesChange,
    onLocationChange,
  };
};
